module.exports = __webpack_public_path__ + "static/media/21-15.b07da4f6.mp3";